"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../../tokens");
var _Control = require("../common/Control");
var _constants = require("../constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledRadio = _styledComponents.default.span.withConfig({
  displayName: "StyledRadio",
  componentId: "sc-6inf4w-0"
})(["display:block;box-sizing:border-box;width:", "px;height:", "px;pointer-events:none;border:2px solid ", ";border-radius:100%;background-repeat:no-repeat;background-position:center;background-size:80%;color:", ";background-color:", ";transition:box-shadow ", " ", ";&:before{content:'';display:block;box-sizing:border-box;height:100%;border-style:solid;border-color:transparent;border-width:", "px;border-radius:100%;background:currentColor;background-clip:content-box;}input:active + &{color:", ";}input:focus + &{box-shadow:0 0 0 ", " ", ";}input:checked + &{color:", ";}", " ", ""], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _tokens.COLOR.GREY.MEDIUM, _tokens.COLOR.WHITE, _tokens.COLOR.WHITE, _tokens.INTERACTIVE.OUTLINE_TRANSITION_DURATION, _tokens.INTERACTIVE.OUTLINE_TRANSITION_EASING, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size === _constants.RADIO_AND_CHECKBOX_SIZES.L ? 6 : 4;
}, _tokens.COLOR.GREY.MEDIUM, _tokens.INTERACTIVE.OUTLINE_WEIGHT, _tokens.COLOR.STATE.ACTIVE, _tokens.COLOR.ACCENT.SECONDARY, _ref4 => {
  let {
    $disabled
  } = _ref4;
  return $disabled && `
    input + && {
      color: ${_tokens.COLOR.GREY.MEDIUM};
    }
  `;
}, _ref5 => {
  let {
    $error
  } = _ref5;
  return $error && `
    input:not(:checked) + & {
      border-color: ${_tokens.COLOR.STATE.ERROR};
    }
  `;
});

/**
## Usage

```js
import { Radio } from '@farewill/ui'
```

### How to use this component

Use the radio component when users can only select one option from a list.

If there are lots of options, consider asking questions that will allow you to present users with fewer options.

Do not use the radio component if users can choose multiple options or toggle an option on and off. In this case, use the checkbox component.

#### Hints

You can add hints to radios to give additional information about the options.

#### Nested content

You can ask the user a related question when they select a particular radio, so they only see the question when it’s relevant to them.

#### Inline radios

In some cases, you can choose to display radios horizontally.

Only use inline radios when the question has two options and both options are short.

### Notes

Any additional props will be spread onto the input element, if you want to add extra attributes to the label element you can with `labelAttributes`.
 */
// eslint-disable-next-line react/display-name
const Radio = exports.Radio = /*#__PURE__*/_react.default.forwardRef((_ref6, forwardedRef) => {
  let {
    size,
    ...props
  } = _ref6;
  const {
    disabled,
    error
  } = props;
  const selectedSize = _constants.RADIO_AND_CHECKBOX_SIZES[size];
  return /*#__PURE__*/_react.default.createElement(_Control.Control, _extends({}, props, {
    ref: forwardedRef,
    type: "radio",
    inputWidth: selectedSize
  }), /*#__PURE__*/_react.default.createElement(StyledRadio, {
    $size: selectedSize,
    $disabled: !!disabled,
    $error: !!error
  }));
});
Radio.defaultProps = {
  size: 'M'
};